/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommunityControllerDtoPostRemoveRequest model module.
 * @module model/CommunityControllerDtoPostRemoveRequest
 * @version 1.0
 */
class CommunityControllerDtoPostRemoveRequest {
    /**
     * Constructs a new <code>CommunityControllerDtoPostRemoveRequest</code>.
     * @alias module:model/CommunityControllerDtoPostRemoveRequest
     * @param postNo {Number} 
     */
    constructor(postNo) { 
        
        CommunityControllerDtoPostRemoveRequest.initialize(this, postNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, postNo) { 
        obj['postNo'] = postNo;
    }

    /**
     * Constructs a <code>CommunityControllerDtoPostRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommunityControllerDtoPostRemoveRequest} obj Optional instance to populate.
     * @return {module:model/CommunityControllerDtoPostRemoveRequest} The populated <code>CommunityControllerDtoPostRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunityControllerDtoPostRemoveRequest();

            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommunityControllerDtoPostRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommunityControllerDtoPostRemoveRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CommunityControllerDtoPostRemoveRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CommunityControllerDtoPostRemoveRequest.RequiredProperties = ["postNo"];

/**
 * @member {Number} postNo
 */
CommunityControllerDtoPostRemoveRequest.prototype['postNo'] = undefined;






export default CommunityControllerDtoPostRemoveRequest;

